import type { AnalyticsCardMarker } from '../../types/chat'
import { useNls } from '../../nls/nlsProvider'

type Props = {
  card?: AnalyticsCardMarker
}

const formatGeneratedAt = (generatedAt: string): string => {
  const date = new Date(generatedAt)
  return Number.isNaN(date.getTime()) ? generatedAt : date.toLocaleString()
}

/** A compact, read-only Analysis snapshot embedded beneath a chat message. */
export const AnalyticsCardBlock = ({ card }: Props) => {
  const { t } = useNls()
  if (!card) return null

  return (
    <section className="chatAnalyticsCard" aria-label={t('NLSChatAnalyticsCardLabel', { title: card.moduleTitle })}>
      <span className="chatAnalyticsCard__eyebrow">{t('NLSAnalysisChatCardEyebrow')}</span>
      <strong className="chatAnalyticsCard__title">{card.moduleTitle}</strong>
      {card.sparklinePngDataUrl ? (
        <img className="chatAnalyticsCard__sparkline" src={card.sparklinePngDataUrl} alt="" />
      ) : (
        <div className="chatAnalyticsCard__sparklinePlaceholder" aria-label={t('NLSChatAnalyticsCardPreviewUnavailable')} />
      )}
      {card.topRecords.length > 0 ? (
        <ul className="chatAnalyticsCard__records">
          {card.topRecords.slice(0, 3).map((record) => (
            <li key={record.id}>
              <span>{record.primary}</span>
              {record.secondary || typeof record.numeric === 'number' ? (
                <small>{[record.secondary, typeof record.numeric === 'number' ? String(record.numeric) : undefined].filter(Boolean).join(' · ')}</small>
              ) : null}
            </li>
          ))}
        </ul>
      ) : null}
      <footer className="chatAnalyticsCard__footer">
        <time dateTime={card.generatedAt}>{t('NLSChatAnalyticsCardGenerated', { timestamp: formatGeneratedAt(card.generatedAt) })}</time>
        <a href={card.deepLinkPath}>{t('NLSAnalysisChatCardOpenInAnalysis')}</a>
      </footer>
    </section>
  )
}
